import { getUserTenantsIns, getUserTenantsOfficeIns, getUserTenantsFlying } from '@yuanfudao/metis-unified-login/es/service/login'
import uniqueIds from '@/config/unique-ids.json'
import {
  loginByPsw,
  loginByFlying
} from '@yuanfudao/metis-unified-login'
import LoginLeftContainer, { LOGIN_TYPE } from '@/pages/login/components/login-left/index'
import ShLoginLeftContainer from '@/pages/login/components/login-left/sh-login'

// import qrCodeIcon from '@/assets/login-new/qr-login-icon.png'
// import codeIcon from '@/assets/login-new/code-login-icon.png'

import lessModule from '@/pages/login/components/code-content/index.module.less'

const ResetPswFeixiang = (props: { onClick: () => void }) => {
  return (
    <button type="button" className={lessModule.forget} onClick={props.onClick}>忘记密码？</button>
  )
}

const loginTypesFeixiang = [
  {
    value: LOGIN_TYPE.CODE,
    // icon: qrCodeIcon,
    label: '验证码登录',
  },
  {
    value: LOGIN_TYPE.PASSWORD,
    // icon: qrCodeIcon,
    label: '密码登录',
  },
  {
    value: LOGIN_TYPE.QRCODE,
    // icon: codeIcon,
    label: '扫码登录',
  },
]

const loginTypesFlying = [
  {
    value: LOGIN_TYPE.PASSWORD,
    // icon: qrCodeIcon,
    label: '密码登录',
  },
]

export const LoginLeftConfig = {
  LoginTypesList: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: loginTypesFeixiang,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: loginTypesFeixiang,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: loginTypesFeixiang,
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: loginTypesFeixiang,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: loginTypesFeixiang,
    [uniqueIds.FLYING_UNIQUE_ID.id]: loginTypesFlying,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: loginTypesFeixiang,
  },
  defaultLoginType: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: LOGIN_TYPE.CODE,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: LOGIN_TYPE.CODE,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: LOGIN_TYPE.CODE,
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: LOGIN_TYPE.CODE,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: LOGIN_TYPE.CODE,
    [uniqueIds.FLYING_UNIQUE_ID.id]: LOGIN_TYPE.PASSWORD,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: LOGIN_TYPE.CODE,
  },
  passwordLoginFn: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: loginByPsw,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: loginByPsw,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: loginByPsw,
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: loginByPsw,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: loginByPsw,
    [uniqueIds.FLYING_UNIQUE_ID.id]: loginByFlying,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: loginByPsw,
  },
  ResetPswComponent: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: ResetPswFeixiang,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: ResetPswFeixiang,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: ResetPswFeixiang,
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: ResetPswFeixiang,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: ResetPswFeixiang,
    [uniqueIds.FLYING_UNIQUE_ID.id]: null,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: ResetPswFeixiang,
  },
  LoginBoxComp: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: LoginLeftContainer,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: LoginLeftContainer,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: LoginLeftContainer,
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: ShLoginLeftContainer,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: LoginLeftContainer,
    [uniqueIds.FLYING_UNIQUE_ID.id]: LoginLeftContainer,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: LoginLeftContainer,
  },
  LoginTenantIdFn: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: getUserTenantsIns,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: getUserTenantsIns,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: getUserTenantsIns,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: getUserTenantsOfficeIns,
    [uniqueIds.FLYING_UNIQUE_ID.id]: getUserTenantsFlying,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: getUserTenantsIns,
  },
  LoginTenantIdFnFilterKey: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: 'inInstitution',
    [uniqueIds.HSMSF_UNIQUE_ID.id]: 'inInstitution',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: 'inInstitution',
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: 'institutionId',
    [uniqueIds.FLYING_UNIQUE_ID.id]: 'inInstitution',
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: 'inInstitution',
  },
  LoginTenantIdFnErrorText: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: '当前账号不在学校内，暂无法使用',
    [uniqueIds.HSMSF_UNIQUE_ID.id]: '当前账号不在学校内，暂无法使用',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: '当前账号不在学校内，暂无法使用',
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: '当前账号不是区域客户无法登录！',
    [uniqueIds.FLYING_UNIQUE_ID.id]: '当前账号不在学校内，暂无法使用',
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: '当前账号不在学校内，暂无法使用',
  },
  goToQrCodeWhenTenantsEmpty: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: false,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: false,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: false,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: true,
    [uniqueIds.FLYING_UNIQUE_ID.id]: false,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: false,
  },
  showSwitchInfo: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: true,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: false,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: false,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: false,
    [uniqueIds.FLYING_UNIQUE_ID.id]: false,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: true,
  }
}
